// @flow
'use strict';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';

import { rootSelector, aplicaFiltro } from '../../../reducers/cte/filtro_livre';

import Formulario from './formulario';

const mapStateToProps = createStructuredSelector({ initialValues: rootSelector });

export default compose(
    connect<*, *, *, *, *, *>(mapStateToProps),
    reduxForm({
      form: 'cteFiltroLivre', enableReinitialize: true,
      onSubmit(form, dispatch) {
        dispatch(aplicaFiltro(form));
      },
    }),
)(Formulario);
